import { configureStore, combineReducers } from "@reduxjs/toolkit";
import type { Action, ThunkAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "../constants/storage";
import { bookingSlice } from "./slices/booking";
import { loginSlice } from "./slices/login";
import { popupSlice } from "./slices/popUp";
import { commonData } from "./slices/commonData";
import  {checkInSlice } from "./slices/checkIn"
import { mobileDropdownSlice }from "./slices/mobileDropDown"
import { eventTrackSlice } from "./slices/eventTracking";
import { flightStatusSlice } from "./slices/flightStatus";
import { modalSlice } from "./slices/modal"
import { travelCertificateSlice } from "./slices/travelCertificate";
import { groupBookingSlice } from "./slices/groupBooking";
import { links } from "./slices/links";
import { resources } from "./slices/resources";
import { webConfig } from "./slices/webConfig";

const persisteConfig = {
  key: "root",
  version: 3,
  storage
};

const persistedReducers = combineReducers({
  booking: bookingSlice.reducer,
  webConfig: webConfig.reducer,
  eventTrack: eventTrackSlice.reducer,
  resources: resources.reducer,
  links: links.reducer,
  checkIn: checkInSlice.reducer,
  commonData: commonData.reducer,
  travelCertificate: travelCertificateSlice.reducer,
  groupBooking: groupBookingSlice.reducer
});

const nonPersistedReducer = combineReducers({
  flightStatus: flightStatusSlice.reducer,
  login: loginSlice.reducer,
  popup: popupSlice.reducer,
  mobile: mobileDropdownSlice.reducer,
  modal: modalSlice.reducer
});

const persistedReducer = persistReducer(persisteConfig, persistedReducers);

const reducer = combineReducers({
  persistedReducers: persistReducer(persisteConfig, persistedReducer),
  nonPersistedReducers: nonPersistedReducer
});

export const store = configureStore({
  reducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
